import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-package-delivered',
  standalone: true,
  templateUrl: '../../assets/package-delivered.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamPackageDeliveredIcon {}
